import type { ApiTmpStorageId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import { authApiConvertTmpStorageOldActions } from './authApiConvertTmpStorageOldActions';
import type { AuthApiTmpStorage } from './types/AuthApiTmpStorage';

type ApiResponse = {
  data: string;
};

function mapResponse(response: ApiResponse) {
  const parsedData = JSON.parse(response.data) as unknown;
  const convertedData = Array.isArray(parsedData)
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      authApiConvertTmpStorageOldActions(parsedData[0])
    : (parsedData as AuthApiTmpStorage);

  return convertedData;
}

const endpoint = new FetchEndpoint({
  urlFactory: (tmpStorageId: ApiTmpStorageId) =>
    `/data/tmp-storage/${tmpStorageId}`,
  mapResponse,
});

// Exports

export const authApiClientFetchTmpStorage = endpoint.client();

export const authApiServerFetchTmpStorage = endpoint.server();
